import React from 'react'
import { Field, WrappedFieldProps } from 'redux-form'

import PureAutoComplete from './PureAutoComplete'

interface Props {
  data: any[]
  messages: {
    label: string
    placeholder?: string
  }
  name: string
  onChange?: any
  onEnter?: any
  onSuggestionsClearRequested: () => void
  onSuggestionSelected?: any
  onSuggestionsFetchRequested: (searchText: string, fieldName: string) => void
  placeholder?: string
  testid: string
}

export const BAutoComplete = ({
  data,
  input,
  messages,
  meta,
  onSuggestionsClearRequested,
  onSuggestionSelected,
  onSuggestionsFetchRequested,
}: Props & WrappedFieldProps) => {
  const hasError = meta.touched && meta.error

  return (
    <>
      <PureAutoComplete
        data={data}
        messages={{ ...messages, error: hasError ? meta.error : undefined }}
        onBlur={input.onBlur}
        name={input.name}
        onChange={input.onChange}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        value={input.value}
      />
    </>
  )
}

const CustomBAutoComplete = (props: Props) => <Field {...props} component={BAutoComplete} />

export default CustomBAutoComplete
